import './sort-selector.scss'

import { PropType } from 'vue';
import Component from "vue-class-component";
import { faSortAmountDown, faSortAmountUp } from '@fortawesome/free-solid-svg-icons';

import { SORT_ORDER_CHANGED, SORT_SELECTED } from '../../events';

import { ReactiveVue } from "@skinsoft/reactive-vue";

@Component({
    props: {
        options: {
            type: Array as PropType<string[]>,
            default: [],
        },
        placeholder: {
            type: String,
            default: 'sortSelector.placeholder'
        },
    },
    template: require('./sort-selector.html')
})
export class SortSelector extends ReactiveVue {
    private options: string[]
    private placeholder: String

    private selected: string | null = null
    private sortAscending: boolean = true

    // Icons
    private sortAscIcon = faSortAmountUp
    private sortDescIcon = faSortAmountDown

    private get computedPlaceholder(): string {
        return this.$t(this.placeholder as string) as string ?? this.placeholder
    }

    private onSelectedValueChanged(value: string) {
        this.$emit(SORT_SELECTED, value)
    }

    private toggleSortAscending() {
        this.sortAscending = !this.sortAscending
        this.$emit(SORT_ORDER_CHANGED, this.sortAscending)
    }
}